module.exports = __webpack_public_path__ + "pattern6.f48d92f9eb9d3351a9ce.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/TerrellDavis/Documents/GitHub/AVL/realavl/realavl/src/img/pattern6.png
// module id = ../../../../../src/img/pattern6.png
// module chunks = styles